import { render } from "./MatchDetailIcon.vue?vue&type=template&id=0982064c&scoped=true"
import script from "./MatchDetailIcon.vue?vue&type=script&lang=js"
export * from "./MatchDetailIcon.vue?vue&type=script&lang=js"

import "./MatchDetailIcon.vue?vue&type=style&index=0&id=0982064c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0982064c"]])

export default __exports__